var Marionette = require('backbone.marionette');

var CommonUtils = require('../../utils/common-utils.js');


var MergePersonDocumentsView = Marionette.View.extend({
    template: require('../../templates/persons/merge-person-documents-view.html'),

    regions: {
    },

    ui: {
        merge: '.merge',
        remove: '.remove'
    },

    events: {
        'click @ui.merge': 'onRowMerge',
        'click @ui.remove': 'onRowRemove'
    },

    templateContext: function () {
        var that = this;
        var mode = that.getOption('mode');
        return {
            mode: mode,
            personId: that.getOption('personId'),
            personName: that.getOption('personName'),
            documents: mode == 'from' ? that.getOption('mergeFromPersonDocumentsModel').get('documents') : that.getOption('mergeToPersonDocumentsModel').get('documents'),
            isMergedDocument: that.isMergedDocument,
            formatDate: function(dt) {
                return (dt == '' || dt == null || dt == 0 ? '' : that.utils.longToDateTimeFormatted(Number(dt), 'MM/DD/YYYY'));
            }
        }
    },

    initialize: function (options) {
        _.bindAll(this, 'onRowMerge', 'onRowRemove', 'triggerUp', 'isMergedDocument');
        this.utils = new CommonUtils();
    },

    onRender: function () {
    },

    onRowMerge: function(event) {
        this.triggerUp('merge:person:documents:row', event, this.getOption('mergeFromPersonDocumentsModel').get('documents'), false);
    },

    onRowRemove: function(event) {
        this.triggerUp('remove:person:documents:row', event, this.getOption('mergeToPersonDocumentsModel').get('documents'), this.isMergedDocument);
    },

    triggerUp: function(action, event, documents, onlyRemove) {
        var id = event.target.id;
        var index = event.target.parentElement.id;
        var document = _.findWhere(documents, {id: id});
        this.triggerMethod(action, {
            document: document,
            insertedIndex: index,
            onlyRemove: _.isFunction(onlyRemove) ? !onlyRemove(document) : onlyRemove
        });

    },

    isMergedDocument: function(d) {
        var that = this;
        return (that.getOption('mergeToPersonDocumentsModelOriginal').get('documents') || []).filter(function(document) {
                return _.isEqual(document, d);
            }).length == 0;
    }
});

module.exports = MergePersonDocumentsView;


//////////////////
// WEBPACK FOOTER
// ./app/views/persons/merge-person-documents-view.js
// module id = 494
// module chunks = 0